const LoadingSpinner = ({ style = 'medium' }) => {

    const width = () => {
        switch (style) {
            case 'large':
                return 'max-w-52'
            case 'medium':
                return 'max-w-32'
            case 'small':
                return 'max-w-16'
            case 'full':
                return ''
            default:
                return 'w-52'
        }
    }

    return (
        <div className='min-h-16 max-h-screen max-w-screen m-auto flex justify-center items-center'>
            <div className={`loading loading-spinner text-primary w-full ${width()}`}></div>
        </div>
    )
}

export default LoadingSpinner